module.exports = "agm-map {\r\n  height: 300px;\r\n}\r\n.pac-container {\r\n  display: block;\r\n  z-index: 100000;\r\n}\r\n.modal-content{\r\n  height: auto;\r\n  margin: 0px;\r\n}\r\n.modal-dialog{\r\n  min-height:auto;\r\n  margin: 0px;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/request-delivery-modal/request-delivery-modal.component.css
// module id = ./src/app/request-delivery-modal/request-delivery-modal.component.css
// module chunks = main